export default __webpack_public_path__ + "static/media/Banner_image_prison_break.b4a1df69.jpg";